import { apiToken } from '@/composables/auth'
import { GACHA_PRIZE, type GachaState } from '@/partners/lingo/lingo-giveaway/types/shared/gacha'
import { callApi } from '@/partners/lingo/lingo-giveaway/services/call-api'

class LingoApi {
  private async fetch<T>(input: {
    path: string,
    body?: object,
    method: 'POST' | 'DELETE' | 'GET'
  }): Promise<T> {
    return await callApi({
      ...input,
      path: `/api${input.path}`,
      headers: {
        'Authorization': `Bearer ${apiToken.value}`,
      },
    })
  }

  public async getSpinState() {
    return await this.fetch<{ state: GachaState, todayEntriesCount: number, currentRaffle: { id: number, endTimestamp: number }, contractAddress: string, winners: Record<number, string>, instantSpinsLeft: number }>({
      path: '/gacha/spin/state',
      method: 'GET',
    })
  }

  public async getRaffleState() {
    return await this.fetch<{ winners: Record<number, string>, raffleId: number }>({
      path: '/gacha/raffle-state',
      method: 'GET',
    })
  }

  public async getDropeeMyWins() {
    return await this.fetch<{ raffleIds: number[] }>({
      path: '/gacha/dropee/my-wins',
      method: 'GET',
    })
  }

  public async incrementEntriesCount(entriesCount: number, raffleId: string) {
    return await this.fetch<{ state: GachaState, todayEntriesCount: number }>({
      path: '/gacha/increment-entries-count',
      method: 'POST',
      body: { entriesCount, raffleId },
    })
  }

  public async spin({ txHash, walletAddress }: { txHash: string, walletAddress: string }) {
    return await this.fetch<{
      state: GachaState,
      prize: GACHA_PRIZE,
      entriesMint: { count: number, signature: string, raffleId: string }
      newTicketsCount: number,
    }>({
      path: '/gacha/spin',
      method: 'POST',
      body: { txHash, walletAddress },
    })
  }

  public async getWinnerSubmissions() {
    return await this.fetch<{
      submissions: Record<number, { walletAddress: string, email: string, country: string, twitter?: string }>
    }>({
      path: '/gacha/winner-submissions',
      method: 'GET',
    })
  }

  public async submitWinner(body: {
    walletAddress: string
    country: string
    raffleId: number
    email: string
    twitter?: string
  }) {
    return await this.fetch<{
      submissions: Record<number, { walletAddress: string, email: string, country: string, twitter?: string }>
    }>({
      path: '/gacha/winner-submissions',
      method: 'POST',
      body: body,
    })
  }
}

export default new LingoApi()
